import { toApiUtcDateTime } from './sriLankaTime';

export const buildResourceAllocationPayload = ({
  allocId,
  userId,
  projectId,
  startDate,
  endDate,
  billablePercentage,
  nonBillablePercentage,
  allocatedBy,
}) => {
  const payload = {
    UserId: Number(userId),
    ProjectId: Number(projectId),
    StartDate: toApiUtcDateTime(startDate),
    EndDate: toApiUtcDateTime(endDate),
    BillablePercentage: Number(billablePercentage),
    NonBillablePercentage: Number(nonBillablePercentage),
    AllocatedBy: Number(allocatedBy),
  };

  if (allocId !== undefined && allocId !== null) {
    payload.AllocId = Number(allocId);
  }

  return payload;
};
